import Vue from 'vue'
import App from './App.vue'
import Vuex from 'vuex';
import router from './router';
import store from './store/index';
import vSelect from 'vue-select'

Vue.component('v-select', vSelect)
Vue.config.productionTip = false
Vue.use(Vuex);
Vue.mixin({
	methods: {
		formatPrice(value) {
			let val = 0;
			if(isNaN(value)){
				val = 0;
			}else{
				val = (value/1).toFixed(2).replace('.', ',')
			}
			return '€ ' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
		},
	},
});


new Vue({
  router,store,
  render: h => h(App),
}).$mount('#app')
